import { useEffect, useState } from "react";
import dayjs from 'dayjs';

const CurrentLocalTimeDisplay = (iana: string) => {
    const [time, setTime] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return dayjs(time).tz(iana).format("MM/DD/YYYY HH:mm:ss");
}

export default CurrentLocalTimeDisplay;
